// extracted by mini-css-extract-plugin
export default {"iconWrapper":"Icon_iconWrapper__EhFEm","hoverable":"Icon_hoverable__29xIp"};